import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/payment-subject/searchbar";
import PaymentSubjectTable from "../../../containers/admin/payment-subject/table";
import AddPaymentSubject from "../../../containers/admin/payment-subject/models/add-payment-subject";
import { getPaymentSubjectRequest } from "../../../modules/admin-modules/videos/Actions";

const PaymentSubject = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getPaymentSubjectRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <PaymentSubjectTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddPaymentSubject
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default PaymentSubject;
